import React, { Component } from 'react'
import { translate } from '../../../utils/useful'

export default class AllBlog extends Component {
    render() {
        return (
            <div className='br-8 flex-column product-view-box bg-white h-100' >
                <div className='flexcc w-100 position-relative' style={{ paddingTop: "80%", backgroundImage: 'url(' + this.props.data.src + ')', backgroundPosition: "center", backgroundSize: "cover", borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                    {/* <img className='w-100 h-100 position-absolute' style={{ objectFit: 'cover' }} src={this.props.data.src} alt="" /> */}
                </div>
                <div className='px-3 mt-2'>
                    <div className='mb-2'>
                        <p className='mt-0 text-smaller fw-600'>{this.props.data.title.length >= 52 ? this.props.data.title.substring(0, 52) + '...' : this.props.data.title}</p>
                        <p className='mb-2 text-smaller color-gray-1 '>{this.props.data.desc.length >= 70 ? this.props.data.desc.substring(0, 70) + '...' : this.props.data.desc}</p>
                    </div>
                    <div className='flexcb my-2'>
                        <span className='text-small mrd-4 color'>{translate(`Read More`)}</span>
                        <img height="14px" src="/images/nexts.png" alt="" />
                    </div>
                </div>
            </div>
        )
    }
}
